import React, { useEffect, useState } from 'react';

const LoadingScreen = ({ onFinish }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(timer);
          setTimeout(() => onFinish && onFinish(), 300);
          return 100;
        }
        return prev + 20;
      });
    }, 100);

    return () => clearInterval(timer);
  }, [onFinish]);

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: '#ffffff',
        zIndex: 99999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '24px'
      }}
    >
      {/* Brand Official Logo */}
      <img
        src="/Rayyandenimlogo.jpeg"
        alt="RAYYAN DENIM"
        style={{
          height: '72px',
          objectFit: 'contain',
          borderRadius: '8px',
          boxShadow: '0 8px 32px rgba(15, 23, 42, 0.08)'
        }}
      />

      <div style={{ textAlign: 'center' }}>
        <p style={{ fontSize: '11px', fontWeight: 800, letterSpacing: '0.22em', color: 'var(--accent-magenta)', textTransform: 'uppercase' }}>
          CRAFTING DENIM...
        </p>
      </div>

      {/* Thin Animated Stitch Progress Line */}
      <div
        style={{
          width: '200px',
          height: '4px',
          background: 'rgba(15, 23, 42, 0.06)',
          borderRadius: '2px',
          overflow: 'hidden',
          position: 'relative'
        }}
      >
        <div
          style={{
            height: '100%',
            width: `${progress}%`,
            background: 'repeating-linear-gradient(90deg, #E00087 0, #E00087 6px, #6D168F 6px, #6D168F 12px)',
            transition: 'width 0.15s linear'
          }}
        />
      </div>
    </div>
  );
};

export default LoadingScreen;
